import React, { useContext } from 'react';
import SlideRoutes from 'react-slide-routes';
import Login from 'Routes/Public/Login/Login';
import { Route } from 'react-router-dom';
import { AnimationPaths } from './AnimationRoutePath/AnimationRoutePath';
import { v4 as uuidV4 } from 'uuid';
import { ControlledRoutes } from './ControlledRoutes';
import { PublicRoutes } from './PublicRoutes';
import TopNav from 'Global/Components/CommonComponents/TopNav/TopNav';
import BottomBar from 'Global/Components/CommonComponents/BottomBar/BottomBar';
import NotFoundPage from 'Global/Components/404/NotFoundPage';
import useCheckScreenWidth from 'Global/Hooks/useCheckScreenWidth';
import { CheckForSignUpEnabled } from 'Global/Functions/CheckForSignUpEnabled';
import Cookies from 'js-cookie';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import AccessControl from 'Global/security/AccessControl';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';

const Router = ({ rootPaths }) => {
  const GlobalConstants = useContext(GlobalContext);
  const isWebAppSettingsEnabled = AccessControl(
    'web-app-setting-accordion'
  );
  const AccessRoles = GlobalConstants?.AccessRoles;

  const screenWidth = useCheckScreenWidth(); // 1024 for Desktop
  const isSignUpEnabled = CheckForSignUpEnabled();
  const user = Cookies.get('user')
    ? JSON.parse(Cookies.get('user'))
    : null;

  const isPatient = user?.AccessRole?.map((role) =>
    role?.toLowerCase()
  )?.includes('patient');

  // const GlobalConstants = useContext(GlobalContext);

  const NobatPrefrences_label = FindLangKey(
    'main-menu-settings-drawer-nobat-prefrences'
  );
  const WebAppSettings = FindLangKey(
    'genral-public-label-wep-app-settings'
  );

  const filterPublicRoutes = PublicRoutes(
    AccessRoles,
    isWebAppSettingsEnabled,
    NobatPrefrences_label,
    WebAppSettings
  )?.filter((fl) => {
    if (!isSignUpEnabled) {
      return fl.path !== '/SignUp';
    } else {
      if (isPatient) {
        return fl;
      } else {
        return fl.path !== '/Wallet';
      }
    }
  });

  // console.log('filterPublicRoutes--->', filterPublicRoutes);

  // console.log('rootPaths--->', rootPaths);

  return (
    <SlideRoutes pathList={AnimationPaths}>
      <Route index path="/" element={<Login />} />
      {filterPublicRoutes?.map((route) => (
        <Route
          key={uuidV4()}
          path={route.path}
          element={
            <>
              {route.title !== null && (
                <TopNav
                  title={route.title}
                  isGeneral={route.isGeneral ?? true}
                />
              )}
              {route.component}
            </>
          }
        />
      ))}

      {ControlledRoutes(rootPaths)?.map((route) =>
        rootPaths.map(
          (paths) =>
            (route.path === paths || route.noAuth) && (
              <Route
                key={uuidV4()}
                path={route.path}
                element={
                  <>
                    {route.title !== null && (
                      <TopNav
                        title={route.title}
                        isGeneral={route.isGeneral ?? true}
                      />
                    )}
                    {route.component}
                    {route.component && (
                      <>
                        <br />
                        <br />
                        <br />
                        {screenWidth <= 1024 ? (
                          <BottomBar />
                        ) : (
                          <></>
                        )}
                      </>
                    )}
                  </>
                }
              />
            )
        )
      )}
      {/* {screenWidth <= 1024 ? <></> : NestedRoutes(word)?.map((route) => rootPaths.map((paths) => route.path === paths && <Route key={uuidV4()} path={route.path} element={<>{route.component}</>} />))} */}

      <Route path="*" element={<NotFoundPage />} />
    </SlideRoutes>
  );
};

export default Router;
